export const expandableRegion = {
    aria: {
        toggleButtonLabel: 'toggle expandable region',
    },
};
//# sourceMappingURL=expandable-region.js.map